module.exports = __webpack_public_path__ + "img/Taboo VI The Homecoming.046b2c36.jpg";